import React, { useState, useEffect, useRef } from 'react';
import { useTheme } from '../../../ThemeContext';
import Header from '../../Layouts/Header';
import Footer from '../../Layouts/Footer';
import Breadcrumb from '../../Layouts/Breadcrumb';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { Grid, Button, Dialog, DialogContent, DialogTitle, DialogActions, CircularProgress } from '@material-ui/core';
import Typography from '@material-ui/core/Typography';
import AuthApi from '../../Services/Authapi';
import parse from 'html-react-parser';
import './Documents.css';
import swal from 'sweetalert';
import FontAwesomeIconComponent from '../../Layouts/FontAwesomeIconComponent';
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import ls from "local-storage";
import Switch from '@material-ui/core/Switch';
import AuthCheckComponent from '../../Layouts/Token';
import CloseIcon from "@material-ui/icons/Close";
import "./Documentslist.css"
import { createSwalLoaderNode } from '../../Layouts/swalLoader';

const EmailTemplates = (props) => {
  const classes = props;
  const [data, setdata] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [hasFetched, setHasFetched] = useState(false);
  const [expandedItems, setExpandedItems] = useState({});
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(null);
  const { darkMode } = useTheme();
  const retryTimeoutRef = useRef(null);

  useEffect(() => {
    if (props && props.authToken === false) {
      // props.history.push('/login');
    }
  });

  useEffect(() => {
    getallemailTemplates();

    return () => {
      if (retryTimeoutRef.current) {
        clearTimeout(retryTimeoutRef.current);
      }
    };
  }, []);

  const getallemailTemplates = async (attempt = 0) => {
    let shouldRetry = false;
    setIsLoading(true);
    try {
      let role = await AuthApi.getallemailTemplates();
      const normalizedTemplates = Array.isArray(role)
        ? role
        : Array.isArray(role?.data)
          ? role.data
          : [];

      if (!Array.isArray(role) && !Array.isArray(role?.data) && attempt < 2) {
        shouldRetry = true;
        retryTimeoutRef.current = setTimeout(() => {
          getallemailTemplates(attempt + 1);
        }, 800);
        return;
      }

      setdata(normalizedTemplates);
    } catch (error) {
      console.error('Error fetching data:', error);
      if (attempt < 2) {
        shouldRetry = true;
        retryTimeoutRef.current = setTimeout(() => {
          getallemailTemplates(attempt + 1);
        }, 800);
        return;
      }
      setdata([]);
    } finally {
      if (!shouldRetry) {
        setIsLoading(false);
        setHasFetched(true);
      }
    }
  };

  const addemailpage = () => {
    props.history.push('/add-email-template');
  };

  const toggleExpanded = (itemId) => {
    setExpandedItems((prevState) => ({
      ...prevState,
      [itemId]: !prevState[itemId],
    }));
  };

  const handleCheckboxChange = async (id, status) => {
    swal({
      title: "Loading",
      text: "Please wait...",
      buttons: false,
      closeOnClickOutside: false,
      closeOnEsc: false,
      width: "10%",
      content: createSwalLoaderNode()
    });
    try {
      let statu = await AuthApi.emailTemplatestatus(id, status);
      swal.close();
      if (statu && statu.status === true) {
        swal("Success", "Email Template status update successfully!", "success");
        getallemailTemplates();
      } else {
        swal("Error", statu, "error");
      }
    } catch (error) {
      swal.close();
      swal("Error", "An error occurred, Please try again later!", "error");
    }
  };

  const handleEdit = (id) => {
    props.history.push(`/edit-email-template/${id}`);
  };

  const handledelete = async (id) => {
    swal({
      title: "Are you sure?",
      icon: "warning",
      buttons: ["Cancel", "Yes"]
    }).then(async (confirm) => {
      if (confirm) {
        let currentPermission = await AuthApi.emailTemplatedelete(id);
        if (currentPermission && currentPermission.status === true) {
          swal("Success", "Email Template deleted successfully!", "success");
          getallemailTemplates();
        } else {
        }
      }
    });
  }

  const User = ls("user");

  const userpermissions = (User && Array.isArray(User.roles) && User.roles[0] && Array.isArray(User.roles[0].permissions))
    ? User.roles[0].permissions.map(permissionObj => permissionObj.name)
    : [];

  const handleViewTemplate = (template) => {
    setSelectedTemplate(template);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
  };

  const sanitizeTemplateHtml = (templateBody = "") => {
    if (typeof templateBody !== "string") {
      return "";
    }

    return templateBody
      .replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, "")
      .replace(/<link\b[^>]*rel\s*=\s*(['"])stylesheet\1[^>]*>/gi, "")
      .replace(/\s(onmouse(?:over|enter|move|down|up|out|leave)|onfocus|onblur)\s*=\s*(['"]).*?\2/gi, "")
      .replace(/\sbgcolor\s*=\s*(['"]).*?\1/gi, "")
      .replace(/\sstyle\s*=\s*(['"])(.*?)\1/gi, (match, quote, styleValue) => {
        const filteredStyle = styleValue
          .split(";")
          .map((rule) => rule.trim())
          .filter(Boolean)
          .filter((rule) => {
            const property = rule.split(":")[0]?.trim().toLowerCase();
            return !["background", "background-color", "background-image"].includes(property);
          })
          .join("; ");

        return filteredStyle ? ` style=${quote}${filteredStyle}${quote}` : "";
      });
  };

  return (
    <div>
      <AuthCheckComponent authToken={props.authToken} />
      {darkMode && (
        <style>{`
          .dark-dialog-paper {
            background-color: #2c2c2c !important;
            color: #ffffff !important;
          }
          .dark-dialog-content {
            background-color: #2c2c2c !important;
            color: #ffffff !important;
          }
          .dark-dialog-content * {
            background-color: transparent !important;
            border-color: #555 !important;
          }
        `}</style>
      )}
      <style>{`
        .email-template-preview {
          background-color: ${darkMode ? '#111111' : '#ffffff'} !important;
          color: ${darkMode ? '#ffffff' : '#111827'};
        }

        .email-template-preview,
        .email-template-preview * {
          background-image: none !important;
        }

        .email-template-preview,
        .email-template-preview *:hover,
        .email-template-preview *:focus,
        .email-template-preview *:active,
        .email-template-preview *::before,
        .email-template-preview *::after {
          background-color: transparent !important;
        }

        .email-template-preview > * {
          background-color: transparent !important;
        }

        .email-template-preview > * * {
          background-color: transparent !important;
        }

        .email-template-preview table,
        .email-template-preview tbody,
        .email-template-preview thead,
        .email-template-preview tfoot,
        .email-template-preview tr,
        .email-template-preview td,
        .email-template-preview th,
        .email-template-preview table:hover,
        .email-template-preview tbody:hover,
        .email-template-preview thead:hover,
        .email-template-preview tfoot:hover,
        .email-template-preview tr:hover,
        .email-template-preview td:hover,
        .email-template-preview th:hover {
          background-color: ${darkMode ? '#111111' : '#ffffff'} !important;
        }

        .email-template-preview,
        .email-template-preview p,
        .email-template-preview div,
        .email-template-preview span,
        .email-template-preview td,
        .email-template-preview th,
        .email-template-preview li,
        .email-template-preview a,
        .email-template-preview strong,
        .email-template-preview b {
          color: ${darkMode ? '#ffffff' : '#111827'} !important;
        }

        .email-template-preview h1,
        .email-template-preview h2,
        .email-template-preview h3,
        .email-template-preview h4,
        .email-template-preview h5,
        .email-template-preview h6 {
          color: ${darkMode ? '#ffffff' : '#0f172a'} !important;
        }
      `}</style>
      <Header
        {...props}
        authUser={props.authUser}
        component={
          <div>
            <Card className={classes.root} style={{ marginBottom: '3%' }}>
              <CardContent>
                <Breadcrumb
                  {...props}
                  primaryPageName="Email Templates"
                  primaryPageLink="/email-templates"
                  isSecondaryPage={false}
                  secondaryPageName=""
                />
              </CardContent>
            </Card>
            <Grid container className={classes.root} spacing={2} style={{ marginBottom: "75px" }}>
              <Grid item xs={12}>
                <Card className={classes.root}>
                  <Grid item xs={12}>
                    <CardContent>
                      <Typography variant="h2" style={{ paddingTop: 0, paddingLeft: 0, paddingBottom: 0, marginBottom: "20px" }}> All Email Templates</Typography>
                    </CardContent>
                    <Button
                      variant="contained"
                      onClick={addemailpage}
                      color="primary"
                      className="common-action-button"
                      style={{ marginLeft: "calc(93% - 24px)", top: "-54px", textTransform: 'capitalize' }}
                    >
                      Add
                    </Button>
                  </Grid>
                  <Grid container className={classes.root} spacing={5} >
                    {isLoading ? (
                      <Grid item xs={12} style={{ padding: "24px", minHeight: "150px", display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", gap: "12px" }}>
                        <CircularProgress size={28} style={{ color: '#036dda' }} />
                        <Typography variant="body1" style={{ color: '#64748b', textAlign: 'center' }}>
                          Loading templates...
                        </Typography>
                      </Grid>
                    ) : Array.isArray(data) && data.length > 0 ? data.map((item) => (
                      <Grid item xs={4} key={item.id} style={{ padding: "3px", }}>
                        <Card className={classes.card} >
                          <CardContent>
                            <Typography variant="h5" component="div">
                              {item.template_name}
                            </Typography>
                            <br />

                            {/* Updated View Button */}
                            {item.template_body?.length > 0 && (
                              <div style={{ position: "relative", zIndex: 10 }}>
                                <Button
                                  className="common-view-button"
                                  style={{
                                    cursor: "pointer",
                                    position: "relative",
                                    zIndex: 11,
                                    textTransform: 'capitalize'
                                  }}
                                  onClick={() => handleViewTemplate(item)}
                                >
                                  View
                                </Button>
                              </div>
                            )}

                            <Grid
                              container
                              className={classes.root}
                              spacing={5}
                              style={{
                                position: "relative",
                                left: "34%",
                              }}
                            >
                              {userpermissions.includes("Emailtemplates.Status") && (
                                <Grid item xs={1} style={{ marginTop: "5px", marginRight: "9px" }}>
                                  <Tooltip title="Status">
                                    <Switch
                                      className="common-status-switch"
                                      checked={item.status === 1}
                                      onChange={() => handleCheckboxChange(item.id, item.status === 1 ? 0 : 1)}
                                      color="primary"
                                    />
                                  </Tooltip>
                                </Grid>
                              )}

                              {userpermissions.includes("Emailtemplates.Edit") && (
                                <Grid item xs={1}>
                                  <Tooltip title="Email Template Edit">
                                    <IconButton
                                      variant="contained"
                                      color="primary"
                                      className="common-action-icon"
                                      onClick={() => handleEdit(item.id)}
                                    >
                                      <FontAwesomeIconComponent
                                        classes="fa fa-edit"
                                        colorName="primary"
                                        fontSize={"small"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              )}

                              {userpermissions.includes("Emailtemplates.Delete") && (
                                <Grid item xs={1}>
                                  <Tooltip title="Delete">
                                    <IconButton
                                      variant="contained"
                                      color="primary"
                                      className="common-action-icon"
                                      onClick={() => handledelete(item.id)}
                                      style={{ marginLeft: " -11px" }}
                                    >
                                      <FontAwesomeIconComponent
                                        classes="fa fa-trash"
                                        colorName="primary"
                                        fontSize={"small"}
                                      />
                                    </IconButton>
                                  </Tooltip>
                                </Grid>
                              )}
                            </Grid>
                          </CardContent>

                        </Card>
                      </Grid>
                    )) : hasFetched ? (
                      <Grid item xs={12} style={{ padding: "12px", minHeight: "150px", display: "flex", justifyContent: "center", alignItems: "flex-start", marginTop: "40px" }}>
                        <Typography variant="body1" style={{ color: '#64748b', textAlign: 'center' }}>
                          No templates available
                        </Typography>
                      </Grid>
                    ) : null}
                  </Grid>
                </Card>
              </Grid>
            </Grid>
          </div>
        }
      />
      <Footer />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        maxWidth="md"
        style={{ marginTop: "35px" }}
        PaperProps={{
          className: darkMode ? "dark-dialog-paper" : ""
        }}
      >
        <DialogTitle style={{ backgroundColor: "#036dda", color: "white", padding: "4px 16px" }}>
          {selectedTemplate?.template_name}
          <CloseIcon
            style={{
              position: "absolute",
              top: 10,
              right: 10,
              cursor: "pointer",
              color: "#fff",
              backgroundColor: "#f44336",
              borderRadius: "50%",
              padding: "2px",
            }}
            onClick={handleCloseDialog}
          />
        </DialogTitle>
        <DialogContent className={darkMode ? "dark-dialog-content" : ""}>
          {selectedTemplate && (
            <div className="email-template-preview">
              {parse(sanitizeTemplateHtml(selectedTemplate.template_body))}
            </div>
          )}
        </DialogContent>
        {/* <DialogActions>
                    <Button onClick={handleCloseDialog} color="primary">
                        Close
                    </Button>
                </DialogActions> */}
      </Dialog>
    </div>
  );
};

export default EmailTemplates;
